import { MouseEvent, useEffect, useState } from 'react'

export const useRippleEffect = () => {
    const [coords, setCoords] = useState({ x: -1, y: -1 })
    const [isRippling, setIsRippling] = useState(false)

    useEffect(() => {
        if (coords.x !== -1 && coords.y !== -1) {
            setIsRippling(true)
            setTimeout(() => setIsRippling(false), 300)
        } else setIsRippling(false)
    }, [coords])

    useEffect(() => {
        if (!isRippling) setCoords({ x: -1, y: -1 })
    }, [isRippling])

    const handleRipple = (e: MouseEvent) => {
        const rect = e.currentTarget.getBoundingClientRect()
        setCoords({ x: e.clientX - rect.left, y: e.clientY - rect.top })
    }

    return { coords, isRippling, handleRipple }
}
